import { BLOQUES } from '@cessi/content';
import type { DimensionCode } from '@cessi/shared';

/** Cantidad total de preguntas puntuables (EV tiene 5 en v1.0). */
export function totalPreguntasPuntuables(): number {
  return BLOQUES.reduce((n, b) => n + b.preguntas.length, 0);
}

/** Índice plano de las preguntas puntuables (orden de bloques). */
export function flatQuestionIndex(bloqueIdx: number, pregIdx: number): number {
  let n = 0;
  for (let b = 0; b < bloqueIdx; b++) {
    n += BLOQUES[b]?.preguntas.length ?? 0;
  }
  return n + pregIdx;
}

export function questionProgressLabel(bloqueIdx: number, pregIdx: number): string {
  const bloque = BLOQUES[bloqueIdx];
  const titulo = bloque?.titulo ?? 'Dimensión';
  const total = bloque?.preguntas.length ?? 4;
  return `${titulo} · ${pregIdx + 1} de ${total}`;
}

export type WizardStep =
  | { kind: 'landing' }
  | { kind: 'registro_a' }
  | { kind: 'registro_b' }
  | { kind: 'bloque0'; page: 2 | 3 }
  | { kind: 'transicion'; code: DimensionCode }
  | { kind: 'pregunta'; bloqueIdx: number; pregIdx: number }
  | { kind: 'review' }
  | { kind: 'resultados' };

/** Secuencia canónica de pantallas del wizard (§4–§5). */
export function buildWizardSteps(): WizardStep[] {
  const steps: WizardStep[] = [
    { kind: 'landing' },
    { kind: 'registro_a' },
    { kind: 'registro_b' },
    { kind: 'bloque0', page: 2 },
    { kind: 'bloque0', page: 3 },
  ];

  for (let b = 0; b < BLOQUES.length; b++) {
    const code = BLOQUES[b]!.code;
    const nPreg = BLOQUES[b]!.preguntas.length;
    steps.push({ kind: 'transicion', code });
    for (let p = 0; p < nPreg; p++) {
      steps.push({ kind: 'pregunta', bloqueIdx: b, pregIdx: p });
    }
  }

  steps.push({ kind: 'review' }, { kind: 'resultados' });
  return steps;
}

export const WIZARD_STEPS = buildWizardSteps();

/** Progreso 0–1 excluyendo landing y resultados. */
export function progressFraction(stepIndex: number): number {
  const actionable = WIZARD_STEPS.filter(
    (s) => s.kind !== 'landing' && s.kind !== 'resultados',
  ).length;
  if (actionable <= 0) return 0;
  const current = WIZARD_STEPS[stepIndex];
  if (!current || current.kind === 'landing') return 0;
  if (current.kind === 'resultados') return 1;
  let seen = 0;
  for (let i = 0; i < stepIndex; i++) {
    const s = WIZARD_STEPS[i];
    if (s && s.kind !== 'landing' && s.kind !== 'resultados') seen++;
  }
  return Math.min(1, (seen + 1) / actionable);
}
